<template>
    <div class="section section-index-promo" id="section-index-promo" v-if="indexPromo != null && setup != null">
        <div class="main-promo-images">
            <div class="pic-elem color-pic" :style="'background-image: url(' + indexPromo.index_promo_images.img_color + ')'">
            </div>
            <div class="pic-elem black-pic" :style="'background-image: url(' + indexPromo.index_promo_images.img_black + ')'">
            </div>
            <div class="content-container">
                <div class="project-title-mobile">
                    <h1>{{indexPromo.title}}</h1>
                </div>
                <div class="container">
                    <div class="logo-bazis">
                        <a :href="setup.logo_bazis.link" target="_blank">
                            <img :src="setup.logo_bazis.img" alt="">
                        </a>
                    </div>
                    <div class="col-right" v-if="changeLang('init')">
                        <div class="lang">
                            <div class="lang--picker">
                                <a href="#" class="lang-link-select">
                                    <!-- <svg-icon icon-class="down-arrow" className="icon-down-arrow"/> -->
                                    <span class="body-lang-ru">Рус</span>
                                    <span class="body-lang-kz">Каз</span>
                                </a>
                            </div>
                            <div class="select--languages">
                                <ul>
                                    <li class="select-link select-link-ru">
                                        <a href="#" @click.prevent="setLocale('')">Рус</a>
                                    </li>
                                    <li class="select-link select-link-kz">
                                        <a href="#" @click.prevent="setLocale('kz/')">Каз</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="phone-modal-btn">
                            <a href="#" class="btn-phone-modal" @click.prevent="openFormModal">
                                <p>{{setup.header_phone}}</p>
                            </a>
                        </div>
                    </div>
                    <div class="link-to-present">
                        <a :href="setup.btn_present_group.file" class="btn-present" target="_blank">
                            <strong>{{setup.btn_present_group.title}}</strong>
                        </a>
                    </div>
                    <div class="col-right-bottom">
                        <a href="#">
                            ПОДЕЛИТЬСЯ MONACO RESIDENCE
                        </a>
                    </div>

                    <div class="menu-elem">
                        <div class="project-title">
                            <h1>{{indexPromo.title}}</h1>
                        </div>
                        <div class="logo">
                            <img :src="setup.logo_white" alt="">
                        </div>
                        <div class="menu-nav-btn" :class="{open: isOpenSendwich}" @click="openMobileMenu(!isOpenSendwich)">
                            <span></span>
                        </div>
                    </div>
                    <li class="online-book-btn" v-if="setup.site_online_booking_init == 'true'">
                        <a href="#" v-scroll-to="{el: '#flats-crm-plans', offset: 0}" class="book-link">
                            <span>ОНЛАЙН БРОНИРОВАНИЕ</span>
                        </a>
                    </li>
                </div>
                <div class="menu-navigation" :class="{open: isOpenSendwich}">
                    <navMain class="index-promo-nav navigation-scroll-spy" :class="{animateLinks: isOpenSendwich}"></navMain>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import navMain from '@/components/nav-main/nav-main.vue'
    export default {
        name: 'indexPromo',
        components: {
            navMain,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            indexPromo: 'loadIndexPromo',
            isOpenSendwich: 'loadIsOpenSendwich',
        }),
        methods: { 
            openFormModal() {
                this.$store.commit('Open_Form_Modal', true);
            },
            openMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
            setLocale(lang) {
                localStorage.setItem('language', lang);
                document.location.reload(true);
            },
            changeLang (init) {
                var dataLang = window.body.data('language'),
                    btnKz = $('.body-lang-kz'),
                    btnRu = $('.body-lang-ru'),
                    selectRu = $('.select-link-ru'),
                    selectKz = $('.select-link-kz'),
                    link = $('.lang-link-select'),
                    switchContainer = $('.select--languages');
                if (dataLang == '') {
                    btnRu.addClass('active');
                    selectRu.addClass('active');
                } else {
                    btnKz.addClass('active');
                    selectKz.addClass('active');
                }
                link.on('click', function(e){
                    e.preventDefault();
                    e.stopPropagation();
                    $(this).stop(true).toggleClass('open');
                    $(this).closest('.lang').find('.select--languages').stop(true).toggleClass('open');
                });
                $(document).on('click', function closeMenu (e){
                    if(link.has(e.target).length === 0){
                        switchContainer.removeClass('open');
                        link.removeClass('open');
                    } else {
                        $(document).one('click', closeMenu);
                    }
                });
                return true;
            },
        },
        mounted () {
            this.changeLang('init');
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    this.changeLang('init');
                    // this.slickyHeader();
                        // this.scrollSpyNavigation();
                }
            )
        },
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/index-promo/index-promo.scss';
    @import '@/styles/components/index-promo/index-promo-respond.scss';
    // @import '@/styles/components/index-promo/media-tablet-pro.scss';
</style>